import { h } from 'preact';
export const AlignRight = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("line", { x1: "21", y1: "10", x2: "7", y2: "10" }),
        h("line", { x1: "21", y1: "6", x2: "3", y2: "6" }),
        h("line", { x1: "21", y1: "14", x2: "3", y2: "14" }),
        h("line", { x1: "21", y1: "18", x2: "7", y2: "18" })));
};
//# sourceMappingURL=align-right.js.map